import { render, staticRenderFns } from "./ChangeSVGLinkText.vue?vue&type=template&id=e49ded82&scoped=true"
import script from "./ChangeSVGLinkText.vue?vue&type=script&lang=js"
export * from "./ChangeSVGLinkText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49ded82",
  null
  
)

export default component.exports